import DefaultLayout from "@/layouts/DefaultLayout";
import KSalesmanForm from "kinnect-front/KSalesmen/KSalesmanForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { Salesman } from "kinnect-models";

export default {
	name: "SalesmanPage",

	metaInfo() {
		const title = this.viewing && this.fetched
			? `Salesmen - ${this.salesman.user.name}`
			: "Salesmen - Add a Salesman";

		return { title: this.fetched ? title : null };
	},

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	props: { idSalesman: Number },

	data: () => ( {
		crud: "salesmen",
		salesman: null,
		deleteDialogOpen: false
	} ),

	computed: {
		viewing() {
			return Boolean( this.idSalesman );
		},

		genDeleteDialog() {
			if ( this.viewing && this.salesman && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete salesman" )}
					onConfirm={() => this.salesman.delete()}
					redirect={[ "back", { name: "salesmen" } ]}
					title="Delete Salesman"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the salesman <strong>{this.salesman.user.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.viewing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Salesman",
					tooltip: "Delete this salesman"
				};
			}
		}
	},

	methods: {
		async fetchSalesman() {
			if ( this.viewing ) {
				this.salesman = await Salesman.findPageModel( this.idSalesman );
			}
		},

		async fetch() {
			await this.fetchSalesman();
		}
	},

	render() {
		return <DefaultLayout maxWidth="500px">
			<KSalesmanForm
				loading={this.$wait.is( "find salesman" )}
				readonly={this.viewing}
				salesman={this.salesman}
			></KSalesmanForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
